import React from "react";
import { animated } from "react-spring";

import Styles from "./TicketsCategoryPlaceholder.styles";
import { TicketsCategoryPlaceholderProps as Props } from "./TicketsCategoryPlaceholder.types";
import usePlaceholderAnimation from "hooks/usePlaceholderAnimation";

const TicketsCategoryPlaceholder: React.FC<Props> = props => {
  const animationStyle = usePlaceholderAnimation();

  const ticketNode = (
    <Styles className="TicketsCategoryPlaceholder__ticket">
      <div className="TicketsCategoryPlaceholder__dot-container TicketsCategoryPlaceholder__left-dot-container">
        <div className="TicketsCategoryPlaceholder__dot" />
      </div>
      <div>
        <animated.div
          className="TicketsCategoryPlaceholder__title TicketsCategoryPlaceholder__left-dot-container"
          style={animationStyle}
        >
          <animated.div
            className="TicketsCategoryPlaceholder__message"
            style={animationStyle}
          />
          <animated.div
            className="TicketsCategoryPlaceholder__description"
            style={animationStyle}
          />
        </animated.div>
      </div>
      <div className="TicketsCategoryPlaceholder__dot-container TicketsCategoryPlaceholder__right-dot-container">
        <div className="TicketsCategoryPlaceholder__dot"></div>
      </div>
    </Styles>
  );

  const ticketsBlock = (
    <>
      <animated.div
        className="TicketsCategoryPlaceholder__header"
        style={animationStyle}
      />
      {ticketNode}
      {ticketNode}
      {ticketNode}
    </>
  );

  return <Styles className="TicketsCategoryPlaceholder">{ticketsBlock}</Styles>;
};

export default TicketsCategoryPlaceholder;
